import { IModel } from '../base/annotation';
import { ExpressCustomSetup, expressCustomSetupTypes } from './expressCustomSetup';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { stringIsNullOrEmpty } from '../../shared/utils/string.util';

export const supportedComponentNames: {[key: string]: string; } = {
    TaskFactory: 'SentryOne.TaskFactory',
    HeddaIO: 'oh22is.HEDDA.IO',
    SqlPhoneticsNet: 'oh22is.SQLPhonetics.NET',
    IntegrationToolkit: 'KingswaySoft.IntegrationToolkit',
    ProductivityPack: 'KingswaySoft.ProductivityPack',
    XtractIS: 'Theobald.XtractIS',
    CDataStandard: 'CData.Standard',
    CDataExtended: 'CData.Extended',
    CDataCloud: 'CData.Cloud',
    AsIntegrationService: 'AecorSoft.IntegrationService'
};

export const shownComponentNames = new Map<string, string>([
    [supportedComponentNames.TaskFactory, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_TaskFactory],
    [supportedComponentNames.HeddaIO, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_HeddaIO],
    [supportedComponentNames.SqlPhoneticsNet, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_SQLPhoneticsNet],
    [supportedComponentNames.IntegrationToolkit, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_IntegrationToolkit],
    [supportedComponentNames.ProductivityPack, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_ProductivityPack],
    [supportedComponentNames.XtractIS, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_XtractIS],
    [supportedComponentNames.CDataStandard, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataStandard],
    [supportedComponentNames.CDataExtended, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataExtended],
    [supportedComponentNames.CDataCloud, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataCloud],
    [supportedComponentNames.AsIntegrationService, shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_AsIntegrationService]
]);

export function isSupportedComponent(componentName: string): boolean {
    for (const key of Object.keys(supportedComponentNames)) {
        if (supportedComponentNames[key] === componentName) {
            return true;
        }
    }
    return false;
}

export function isLicensedComponent(componentName: string): boolean {
    return !stringIsNullOrEmpty(componentName)
        && componentName !== supportedComponentNames.HeddaIO
        && componentName !== supportedComponentNames.CDataCloud
        && isSupportedComponent(componentName);
}

@Metamodel.model({
    name: 'ComponentSetup',
    display: [shellStringResources.ModelName_ComponentExtension, shellStringResources.ModelName_ComponentExtensions]
})
export class ComponentSetup extends ExpressCustomSetup {
    public static readonly MODEL: IModel;

    public componentName: string;

    constructor(name?: string, public description?: string) {
        super(expressCustomSetupTypes.Installation, name, description);
    }

    public getCustomSetupName(): string {
        if (this.componentName) {
            return shownComponentNames.get(this.componentName);
        }
        return shellStringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_Unknown;
    }

    public coincideWith(customSetup: ExpressCustomSetup): void {
        if (this.customSetupType === customSetup.customSetupType) {
            const setup = customSetup as ComponentSetup;
            this.componentName = setup.componentName;
        }
    }

    public validate(): boolean {
        return !stringIsNullOrEmpty(this.componentName);
    }
}
